/**
 * Rates are displayed according to the dominant currency in the pair
 * The dominant currency is determined based on the order returned by the API
 * The currency order array is located in /settings?keys[]=currency under the name "symbols"
 */

export const orderPairByDominance = (
  currency1: string,
  currency2: string,
  currencies: string[],
): [string, string] | null => {
  const currency1Position = currencies.indexOf(currency1)
  const currency2Position = currencies.indexOf(currency2)

  if (currency1Position === -1) {
    console.warn(`Currency ${currency1} not found in the dominance list.`)
    return null
  }

  if (currency2Position === -1) {
    console.warn(`Currency ${currency2} not found in the dominance list.`)
    return null
  }

  if (currency1Position === currency2Position) {
    console.warn(`Currencies ${currency1} and ${currency2} are the same. No dominance.`)
    return [currency1, currency2]
  }

  const marketBaseCurrency = currency1Position < currency2Position ? currency1 : currency2
  const marketCounterCurrency = currency1Position < currency2Position ? currency2 : currency1

  return [marketBaseCurrency, marketCounterCurrency]
}

export const base = (currency1: string, currency2: string, currencies: string[]): string | null => {
  const ordered = orderPairByDominance(currency1, currency2, currencies)
  return ordered && ordered[0]
}

export const counter = (currency1: string, currency2: string, currencies: string[]): string | null => {
  const ordered = orderPairByDominance(currency1, currency2, currencies)
  return ordered && ordered[1]
}
